import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
  },
  reducers: {
    setUserDetails: (state, action) => {
      state.user = {
        id: action.payload?.id,
        company_id: action.payload?.company_id,
        name: action.payload?.name,
        email: action.payload?.email,
        phone_number: action.payload?.phone_number,
        image: action.payload?.image,
        role: action.payload?.role,
        company_domain: action.payload?.company_domain,
        settings: {
          default_extension: {
            extension: action.payload?.settings?.default_extension?.extension,
            password: action.payload?.settings?.default_extension?.password,
            caller_id: action.payload?.settings?.default_extension?.caller_id,
          },
          auto_connect: action.payload?.settings?.auto_connect || true,
        },
        is_demo_account: action.payload?.is_demo_account || false,
      };
    },
    updateUserDetails: (state, action) => {
      state.user = {
        id: action.payload?.id || state?.user?.id,
        company_id: action.payload?.company_id || state?.user?.company_id,
        name: action.payload?.name || state?.user?.name,
        email: action.payload?.email || state?.user?.email,
        phone_number: action.payload?.phone_number || state?.user?.phone_number,
        image: action.payload?.image || state?.user?.image,
        role: action.payload?.role || state?.user?.role,
        company_domain: action.payload?.company_domain || state?.user?.company_domain,
        settings: {
          default_extension: {
            extension:
              action.payload?.settings?.default_extension?.extension ||
              state?.user?.settings?.default_extension?.extension,
            password:
              action.payload?.settings?.default_extension?.password ||
              state?.user?.settings?.default_extension?.password,
            caller_id:
              action.payload?.settings?.default_extension?.caller_id ||
              state?.user?.settings?.default_extension?.caller_id,
          },
          auto_connect:
            action.payload?.settings?.auto_connect || state?.user?.settings?.auto_connect,
        },
        is_demo_account: action.payload?.is_demo_account || state?.user?.is_demo_account,
      };
    },
    removeDefaultExtension: (state) => {
      state.user.settings = {
        ...state?.user?.settings,
        default_extension: {
          extension: "",
          password: "",
          caller_id: "",
        },
      };
    },
    clearUser: (state) => {
      state.user = null;
    },
  },
});

export const { setUserDetails, updateUserDetails, clearUser, removeDefaultExtension } =
  userSlice.actions;

export default userSlice.reducer;
